export default __webpack_public_path__ + "static/media/land.43e4413f.jpg";